import { injectable, inject } from "inversify";

import { HttpService } from "src/core/services/http.service";

@injectable()
export default class AuditService {
	@inject(HttpService)
	private httpService: HttpService;

	public getAuditHistory(id: string, preffix: string = '', pageIndex = -1, pageSize = 0) {
		return this.httpService.post('/api/v1/audit/history', {
			pageIndex,
			pageSize,
			preffix,
			id,
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/general/audit/audit.service.ts